import { Plus, Trash2 } from "lucide-react";

export const Field = ({ label, value, onChange, textarea, testid, placeholder }) => (
  <div>
    <label className="admin-label">{label}</label>
    {textarea ? (
      <textarea className="admin-input" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} placeholder={placeholder} />
    ) : (
      <input className="admin-input" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} placeholder={placeholder} />
    )}
  </div>
);

export const Select = ({ label, value, onChange, options, testid }) => (
  <div>
    <label className="admin-label">{label}</label>
    <select className="admin-input" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </div>
);

export const LinesField = ({ label, value, onChange, testid }) => (
  <Field label={`${label} (one per line, blank line = new paragraph)`} textarea value={(value || []).join("\n\n")} onChange={(v) => onChange(v.split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean))} testid={testid} />
);

export const ImageField = ({ label, value, onChange, assets, testid }) => (
  <div>
    <label className="admin-label">{label}</label>
    <div className="flex gap-2">
      <input className="admin-input" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://… or /assets/…" data-testid={testid} />
      <select className="admin-input" style={{ width: 170 }} value="" onChange={(e) => e.target.value && onChange(e.target.value)} data-testid={`${testid}-picker`}>
        <option value="">Asset library…</option>
        {assets.map((a) => <option key={a} value={a}>{a.replace("/assets/", "")}</option>)}
      </select>
    </div>
    {value && <img src={value} alt="" className="mt-2 object-cover" style={{ height: 70, width: 110 }} />}
  </div>
);

export const ListEditor = ({ label, items, onChange, blank, render, testid }) => {
  const update = (i, patch) => onChange(items.map((it, k) => (k === i ? { ...it, ...patch } : it)));
  const remove = (i) => onChange(items.filter((_, k) => k !== i));
  return (
    <div className="admin-block">
      <div className="flex items-center justify-between mb-3">
        <span className="admin-label" style={{ marginBottom: 0 }}>{label} ({items.length})</span>
        <button type="button" className="btn-silver" style={{ padding: "5px 10px", fontSize: 9 }} onClick={() => onChange([...items, blank()])} data-testid={`${testid}-add`}><Plus size={11} /> Add</button>
      </div>
      <div className="flex flex-col gap-3">
        {items.map((it, i) => (
          <div key={i} className="grid gap-2 p-3" style={{ background: "#0f0f0f", border: "1px solid rgba(217,218,221,0.08)" }} data-testid={`${testid}-row-${i}`}>
            {render(it, (patch) => update(i, patch), i)}
            <button type="button" className="justify-self-end inline-flex items-center gap-1 text-xs" style={{ color: "#ff8a9b" }} onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`}><Trash2 size={12} /> Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
};
